import { Wind } from 'lucide-react';
import { cardBase, ViewAllLink } from './dashboardUtils';

function statusLabel(item) {
  if (item.days_until < 0) return { text: `Overdue ${Math.abs(item.days_until)}d`, tone: 'red' };
  if (item.days_until === 0) return { text: 'Due today', tone: 'amber' };
  return { text: `Due in ${item.days_until}d`, tone: 'amber' };
}

export function FiltersWidget({ filters }) {
  const items = filters || [];
  return (
    <div className={`${cardBase} overflow-hidden`} data-testid="dashboard-filters-widget">
      <div className="flex items-center justify-between px-6 pt-5 pb-3">
        <h2 className="text-[15px] font-semibold text-gray-900 flex items-center gap-2">
          <Wind className="h-4 w-4 text-gray-400" /> Filters Due This Week
        </h2>
        <ViewAllLink to="/maintenance?tab=ac-filters" label="ac-filters" />
      </div>
      <div className="px-6 pb-5">
        {items.length === 0 ? (
          <p className="text-[13px] text-gray-400 py-2" data-testid="dashboard-filters-empty">All caught up — no filters due this week</p>
        ) : (
          <div className="space-y-0">
            {items.slice(0, 5).map(f => {
              const st = statusLabel(f);
              const toneBg = st.tone === 'red' ? 'text-red-700 bg-red-50' : 'text-amber-700 bg-amber-50';
              const toneDot = st.tone === 'red' ? 'bg-red-500' : 'bg-amber-500';
              return (
                <div key={f.unit_id} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0" data-testid={`filter-item-${f.unit_id}`}>
                  <div className="min-w-0">
                    <p className="text-[13px] font-medium text-gray-900 truncate">
                      {f.property_name || 'Unassigned'} · Unit {f.unit_number}
                    </p>
                    <p className="text-[11px] text-gray-400 mt-0.5">
                      {f.filter_size ? `${f.filter_size} · ` : ''}Next due {f.next_due}
                    </p>
                  </div>
                  <span className={`inline-flex items-center gap-1 text-[11px] font-medium rounded-full px-2.5 py-0.5 ${toneBg} flex-shrink-0`}>
                    <span className={`h-1.5 w-1.5 rounded-full ${toneDot}`} />
                    {st.text}
                  </span>
                </div>
              );
            })}
            {items.length > 5 && (
              <p className="text-[11px] text-gray-400 pt-2">+{items.length - 5} more</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
